import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import ContestIdsSnippetNotFoundError from './contest-ids-snippet-not-found-error';
import {contestIdsSnippetMap} from 'components/organisms/late-swap/services/maps';

const ContestIdsSnippetFactory = {
    getSnippet(sportConfig): ArraySnippetInterface {
        const site = sportConfig.getSite().toLowerCase();

        try {
            return contestIdsSnippetMap[site]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new ContestIdsSnippetNotFoundError('Snippet is undefined');
            }
            throw e;
        }
    },
};

export default ContestIdsSnippetFactory;
